import React from "react";
import "./style.css";
import { Title } from "../Title";
import ThumbVideo from "./thumb-video.png";

export const About = ({ className, content }) => {
  const about = content.sections.about;

  return (
    <section id="about" className={`about ${className} position-relative`}>
      <div className="container">
        <Title
          title={about.title}
          subtitle={about.subtitle}
          description={about.description}
        />
        <div className="row justify-content-center">
          <div className="col-lg-4 col-12 text-left">
            {about.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          <div className="about-video col-lg-6 col-12">
            <img
              src={ThumbVideo}
              alt="About the instantors"
              className="w-100"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
